import { scaleMobile } from "../..";

/**
 * Use `visible` together with `useLayoutEffect` to avoid flickering.
 * This is needed because the SVG icons of ant are a bit flickering.
 */
function commonInlineStyleGroupsCheckbox(_ref, visible, checked, disabled, fontSize) {
  var borderRadius = _ref.layout.borderRadius,
      _ref$group = _ref.group,
      headlineFontSize = _ref$group.headlineFontSize,
      checkboxBg = _ref$group.checkboxBg,
      checkboxBorderWidth = _ref$group.checkboxBorderWidth,
      checkboxBorderColor = _ref$group.checkboxBorderColor,
      checkboxActiveBg = _ref$group.checkboxActiveBg,
      checkboxActiveBorderColor = _ref$group.checkboxActiveBorderColor,
      checkboxActiveColor = _ref$group.checkboxActiveColor,
      antiAdBlocker = _ref.customCss.antiAdBlocker,
      mobile = _ref.mobile,
      pageRequestUuid4 = _ref.pageRequestUuid4;
  var useFontSize = fontSize || headlineFontSize;
  useFontSize = pageRequestUuid4 ? scaleMobile(mobile, pageRequestUuid4, useFontSize) : useFontSize;
  var useCheckboxBorderWidth = pageRequestUuid4 ? scaleMobile(mobile, pageRequestUuid4, +checkboxBorderWidth) : +checkboxBorderWidth;
  var height = +useFontSize + useCheckboxBorderWidth * 2 + 6;
  return {
    className: antiAdBlocker === "y" ? undefined : "rcb-checkbox",
    style: {
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.5 : undefined,
      color: checked ? checkboxActiveColor : checkboxBg,
      display: visible ? "inline-block" : "none",
      background: checked ? checkboxActiveBg : checkboxBg,
      border: "".concat(useCheckboxBorderWidth, "px solid ").concat(checked ? checkboxActiveBorderColor : checkboxBorderColor),
      padding: 3,
      height: height,
      width: height,
      marginRight: 10,
      borderRadius: +borderRadius,
      verticalAlign: "middle",
      lineHeight: 0,
      boxSizing: "border-box"
    }
  };
}

export { commonInlineStyleGroupsCheckbox };